import Image from "next/legacy/image";
import { format } from "date-fns";

import { useEffect, useState } from "react";
import { convertToShortMonth } from "../../../utils/helpers/dateAndTime";

const NewsDetailAuthorAndDate = ({
  authorAvatar,
  authorFullName,
  articleDateTime,
}) => {
  const [formattedDateTime, setFormattedDateTime] = useState("");

  useEffect(() => {
    setFormattedDateTime(convertToShortMonth(articleDateTime));
  }, [articleDateTime]);

  return (
    <>
      <div className="flex justify-between items-center px-6 sm:px-6 md:px-0 lg:px-0 xl:px-0 2xl:px-0 mt-6 mb-4 max-w-prose mx-auto">
        <div className="flex justify-center items-center space-x-2">
          <Image
            src={authorAvatar}
            objectFit="cover"
            height="32px"
            width="32px"
            alt="Author Avatar"
            quality={100}
            className="inline-block rounded-full"
          />

          <p className="text-xs">by {authorFullName}</p>
        </div>
        <p className="text-xs">{formattedDateTime}</p>
      </div>
    </>
  );
};

export default NewsDetailAuthorAndDate;
